import styled from 'styled-components';
import type { ExtendedPlaceholderInventoryModel } from 'autogen/swagger/all';
import { getNumberOfItems, InventoryLaneList } from 'components/connectedContent/inventoryLaneConnectedContent';
import { Typography } from 'components/generic/typography';
import { breakpoint } from 'variables';

const Wrapper = styled.div<{ $noOfItemsMobile: number; $noOfItemsDesktop: number }>`
    display: ${({ $noOfItemsMobile }) => ($noOfItemsMobile === 0 ? 'none' : 'block')};
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    padding-top: ${({ theme }) => theme.Spacing16};
    padding-bottom: ${({ theme }) => theme.Spacing24};
    padding-left: ${({ theme }) => theme.Spacing16};
    padding-right: ${({ theme }) => theme.Spacing16};
    margin-left: -${({ theme }) => theme.Spacing16};
    margin-right: -${({ theme }) => theme.Spacing16};

    ${breakpoint.up('768px')} {
        display: ${({ $noOfItemsDesktop }) => ($noOfItemsDesktop === 0 ? 'none' : 'block')};
        padding-top: ${({ theme }) => theme.Spacing32};
        padding-bottom: ${({ theme }) => theme.Spacing32};
    }
`;

const StyledHeadline = styled(Typography.Headline)`
    margin-bottom: ${({ theme }) => theme.Spacing24};

    ${breakpoint.up('768px')} {
        text-align: center;
    }
`;

export default function InventoryLane({ model }: { model: ExtendedPlaceholderInventoryModel }): JSX.Element | null {
    const { heading, inventoryLane, hideHeader } = model;

    if (!inventoryLane) return null;
    const { noOfItemsDesktop, noOfItemsMobile } = getNumberOfItems(inventoryLane);
    const headline = heading ?? inventoryLane.inventoryLaneHeader;

    return (
        <Wrapper $noOfItemsDesktop={noOfItemsDesktop} $noOfItemsMobile={noOfItemsMobile}>
            {!hideHeader && <StyledHeadline size="L">{headline}</StyledHeadline>}
            <InventoryLaneList content={inventoryLane} />
        </Wrapper>
    );
}
